import { Dataset } from "../types/api";

// A dataset stored as an Excel workbook (see backend UploadDataset) offers a
// choice at download time: the full workbook, or a flattened CSV view.
// Anything else was always CSV, so there's nothing to choose.
export function isWorkbookDataset(dataset: Dataset): boolean {
  return dataset.data_type === "xlsx";
}

export function isXlsxFilename(filename: string | undefined): boolean {
  return (filename ?? "").toLowerCase().endsWith(".xlsx");
}

// Saves a downloaded blob under a name/extension matching what was actually
// requested — "native" for datasets stored as a workbook is a real .xlsx.
export function saveDatasetBlob(
  blob: Blob,
  dataset: Dataset,
  format: "native" | "csv",
): void {
  const ext = isWorkbookDataset(dataset) && format === "native" ? "xlsx" : "csv";
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${dataset.display_name.replace(/\s+/g, "_")}_pseudonymized.${ext}`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
